import { render, staticRenderFns } from "./SurveysList.vue?vue&type=template&id=35fdff88&scoped=true&"
import script from "./SurveysList.vue?vue&type=script&lang=js&"
export * from "./SurveysList.vue?vue&type=script&lang=js&"
import style0 from "./SurveysList.vue?vue&type=style&index=0&id=35fdff88&lang=scss&scoped=true&"
import style1 from "./SurveysList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fdff88",
  null
  
)

export default component.exports